import {
  JsonapiEntity,
  ManyUnresolvedIdentifiersOr,
  attribute,
  entity,
  meta,
  relationship,
} from '@talisdev/jsonapi-transformers';

import { Tenant } from '®shared/tenant';

import { EditableSection } from './editable-section';
import { ListItem } from './list-item';
import { ReadingListDetails } from './reading-list-details';

type ManyUnresolvedIdentifiersOrSectionOrItem = ManyUnresolvedIdentifiersOr<
  Section | ListItem
>;

@entity({ type: 'sections' })
export class Section extends JsonapiEntity<Section> implements EditableSection {
  @attribute() title: string;
  @attribute() description?: string;
  @relationship({ allowUnresolvedIdentifiers: true })
  all_children?: ManyUnresolvedIdentifiersOrSectionOrItem;
  @relationship() list?: ReadingListDetails;
  @relationship() rolled_over_to?: Section;
  @relationship() rolled_over_from?: Section;
  @relationship() tenant?: Tenant;

  /**
   * We alias `sections` so we can ensure that it returns an array
   */
  @relationship({ name: 'sections' })
  legacySections?: Section[];

  @meta() item_count?: number;

  get sections(): Section[] {
    if (!this.all_children) {
      return [];
    }
    return this.all_children
      .filter(child => child.type === 'sections')
      .map(section => section as Section);
  }
}
